export const mockBasicInfo = {
    classifications: [
        {
            id: 1,
            classification: "전자제품",
            createdTime: "2024-01-15T09:00:00.000Z",
            modifiedTime: "2024-01-15T09:00:00.000Z",
            creater: 1,
            modifier: null,
            deletedYn: 0,
        },
        {
            id: 2,
            classification: "의류",
            createdTime: "2024-01-16T10:30:00.000Z",
            modifiedTime: "2024-01-16T10:30:00.000Z",
            creater: 1,
            modifier: null,
            deletedYn: 0,
        },
        {
            id: 3,
            classification: "식품",
            createdTime: "2024-01-17T14:15:00.000Z",
            modifiedTime: "2024-01-17T14:15:00.000Z",
            creater: 1,
            modifier: null,
            deletedYn: 0,
        },
        {
            id: 4,
            classification: "가구",
            createdTime: "2024-01-18T11:45:00.000Z",
            modifiedTime: "2024-01-18T11:45:00.000Z",
            creater: 1,
            modifier: null,
            deletedYn: 0,
        },
    ],
    manufacturers: [
        {
            id: 1,
            manufacturer: "삼성전자",
            createdTime: "2024-01-15T09:00:00.000Z",
            modifiedTime: "2024-01-15T09:00:00.000Z",
            creater: 1,
            modifier: null,
            deletedYn: 0,
        },
        {
            id: 2,
            manufacturer: "LG전자",
            createdTime: "2024-01-16T10:30:00.000Z",
            modifiedTime: "2024-01-16T10:30:00.000Z",
            creater: 1,
            modifier: null,
            deletedYn: 0,
        },
        {
            id: 3,
            manufacturer: "애플",
            createdTime: "2024-01-17T14:15:00.000Z",
            modifiedTime: "2024-01-17T14:15:00.000Z",
            creater: 1,
            modifier: null,
            deletedYn: 0,
        },
        {
            id: 4,
            manufacturer: "나이키",
            createdTime: "2024-01-18T11:45:00.000Z",
            modifiedTime: "2024-01-18T11:45:00.000Z",
            creater: 1,
            modifier: null,
            deletedYn: 0,
        },
        {
            id: 5,
            manufacturer: "아디다스",
            createdTime: "2024-01-19T16:20:00.000Z",
            modifiedTime: "2024-01-19T16:20:00.000Z",
            creater: 1,
            modifier: null,
            deletedYn: 0,
        },
    ],
    spots: [
        {
            id: 1,
            spot: "서울 강남점",
            createdTime: "2024-01-15T09:00:00.000Z",
            modifiedTime: "2024-01-15T09:00:00.000Z",
            creater: 1,
            modifier: null,
            deletedYn: 0,
        },
        {
            id: 2,
            spot: "부산 해운대점",
            createdTime: "2024-01-16T10:30:00.000Z",
            modifiedTime: "2024-01-16T10:30:00.000Z",
            creater: 1,
            modifier: null,
            deletedYn: 0,
        },
        {
            id: 3,
            spot: "대구 동성로점",
            createdTime: "2024-01-17T14:15:00.000Z",
            modifiedTime: "2024-01-17T14:15:00.000Z",
            creater: 1,
            modifier: null,
            deletedYn: 0,
        },
        {
            id: 4,
            spot: "인천 송도점",
            createdTime: "2024-01-18T11:45:00.000Z",
            modifiedTime: "2024-01-18T11:45:00.000Z",
            creater: 1,
            modifier: null,
            deletedYn: 0,
        },
        {
            id: 5,
            spot: "광주 상무점",
            createdTime: "2024-01-19T16:20:00.000Z",
            modifiedTime: "2024-01-19T16:20:00.000Z",
            creater: 1,
            modifier: null,
            deletedYn: 0,
        },
        {
            id: 6,
            spot: "대전 둔산점",
            createdTime: "2024-01-20T13:10:00.000Z",
            modifiedTime: "2024-01-20T13:10:00.000Z",
            creater: 1,
            modifier: null,
            deletedYn: 0,
        },
    ],
};
